import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MediaBankFileUploadDetailComponent } from './media-bank-file-upload-detail.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@NgModule({
    imports: [CommonModule, FiAppTextSharedModule, MatProgressBarModule],
    declarations: [MediaBankFileUploadDetailComponent],
    exports: [MediaBankFileUploadDetailComponent],
})
export class MediaBankFileUploadDetailModule {}
